import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { PortalAuthProvider } from "./contexts/PortalAuthContext";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
            <PortalAuthProvider>
                <ToastProvider>
                    <App />
                </ToastProvider>
            </PortalAuthProvider>
        </AuthProvider>
    </ThemeProvider>
);

reportWebVitals();
